<template>
    <div>
        <modal :name="modal_name" class="final-modal note-modal cancellation-reject-popup-ui-fix" transition="nice-modal-fade">
            <div class="v-modal-content" style="border-radius: 15px;">
                <div class="v-modal-header justify-content-center">
                    <span class="v-modal-dialog-title-ar v-modal-title">Reason for Rejection</span>
                    <button style="position: absolute;top:12px;right:12px" type="button" class="closeModal" aria-label="Close" @click="hideRejection()">
                        <span aria-hidden="true">
                            <i class="icon icon-close text-white" style="line-height: 2.4rem !important;"></i>
                        </span>
                    </button>
                </div>
                <div class="general-section pb-2 pl-4 pr-4" style="background: #fff !important;overflow: auto;">
                    <div class="pt-0 pb-0">
                        <div class="d-form" >
                            <div class="mt-3 mb-7" style="max-height: 300px;">
                                <div class="position-relative">
                                    <div class="pb-2" style="background: white !important;">
                                        <textarea class="form-control text-area" v-validate="'required'" name="reject" v-model="rejection_data.action.comment" maxlength="1000" placeholder="Enter Reason for Rejection" />
                                    </div>    
                                    <span class="invalid-feedback-form text-danger mt-0 text-left d-block fs-13 position-absolute" v-show="errors.has('reject')">{{ errors.first('reject')}}</span>
                                    <div class=" mt-1 d-flex justify-content-end">
                                        <span class="text-right d-block">{{1000-rejection_data.action.comment.length}}/1000</span>
                                    </div>
                                </div>
                                <div class="d-flex align-items-center">
                                    <span class="text-secondary mt-2 d-block mb-2 fs-14 font-weight-bold">Attachments</span>
                                    <label class="choose-file ml-2 btn-upload" v-if="rejection_data.action.attachments.length < 10 && !isUploadingInProgress">
                                        <img src="/static/images/upload-icon-button.png" width="25" height="25" alt="">
                                        <input id="multiple" type="file" @change="uploadAttachment" accept=".pdf,.doc,.docx,.csv,.ods,.zip,.xls,image/*">
                                        Upload
                                    </label>
                                    <label class="choose-file ml-2 btn-upload-disabled cursor-notallowed" v-else>
                                        <img src="/static/images/upload-icon-button.png" width="25" height="25" alt="">
                                        <!-- <input id="multiple" type="file" @change="uploadAttachment" accept=".pdf,.doc,.xls,image/*"> -->
                                        Upload
                                    </label>
                                </div>
                                <div class="drag-drop-area img-upload bg-modal-grey w-100 text-center mt-2" id="drop_zone_inside" @drop="dropAttachment($event)" @dragover="dragOverAttachment($event)">
                                    <div class="d-flex justify-content-center align-items-center mb-2">
                                        <img src="/static/images/upload-icon.svg" width="20" alt="">
                                    </div>
                                    <span class="dd-text fs-14">Drag and Drop File</span>
                                </div>
                                <div class="pb-2 pt-2 mt-5" style="background: white !important;">
                                    <div class="pb-3">
                                        <!-- <div class="d-flex justify-content-center">
                                            <div class="img-upload bg-modal-grey pt-3 pb-2 pl-10 pr-10 text-center bg-white">
                                                <label class="choose-file">
                                                    <input id="multiple" type="file" @change="uploadAttachment" accept=".pdf,.doc,.xls,image/*">
                                                    Choose Files
                                                </label>
                                            </div>
                                        </div> -->
                                        <div class="d-flex flex-wrap align-items-center mt-1" v-if="rejection_data.action.attachments.length > 0">
                                            <div class="col-lg-12 col-md-12 col-sm-12" v-for="(attachment,index) in rejection_data.action.attachments" :key="index">
                                                <div class="d-flex align-items-center mt-6 pr-6">
                                                    <div class="d-flex align-items-center">
                                                        <div>
                                                            <img v-if="attachment.name.endsWith('.pdf')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg">
                                                            <img v-else-if="attachment.name.endsWith('.zip') || attachment.name.endsWith('.ZIP')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/zip-icon.svg">
                                                            <img v-else-if="attachment.name.endsWith('.csv') || attachment.name.endsWith('.CSV')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/csv_logo.svg">
                                                            <img v-else-if="attachment.name.endsWith('.ODS') || attachment.name.endsWith('.ods')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/ods_logo.svg">
                                                            <img v-else-if="attachment.name.endsWith('.png')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/png-attachment.svg">
                                                            <img v-else-if="attachment.name.endsWith('.jpg')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/jpg.svg">
                                                            <img v-else-if="attachment.name.endsWith('.svg')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg">
                                                            <img v-else-if="attachment.name.endsWith('.xls') || attachment.name.endsWith('.xlsx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg">
                                                            <img v-else-if="attachment.name.endsWith('.doc') || attachment.name.endsWith('.docx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg">
                                                        </div>
                                                        <div class="col">
                                                            <div class="d-flex justify-content-between">
                                                                <el-tooltip :content="attachment.name" placement="top">
                                                                    <div class="font-weight-bold text-truncate d-block mx-width-220">
                                                                        {{attachment.name}}
                                                                    </div>
                                                                </el-tooltip>
                                                            </div>
                                                            <div v-if="attachment.progress<100">
                                                                <progress-bar class="progressBar w-100" :class="{'error-upload':attachment.progress<100 && error != ''}" :val="attachment.progress" size="small"></progress-bar>
                                                            </div>    
                                                            <div class="d-flex justify-content-between">
                                                                <div class="text-danger pl-0 fw-500" v-if="attachment.progress<100 && error != ''">{{error}}...</div>
                                                                <div class="text-secondary fw-500" v-if="attachment.progress<100 && error == ''">{{attachment.progress}}% Uploaded</div>
                                                                <div class="fw-500" v-if="attachment.error == ''">{{attachment.size * 0.001 + ' KB' | prettyBytes}}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="pointer" style="width:10%" @click="deleteAttachment(attachment,index)">
                                                        <i class="icon icon-close fs-16 closeAttachment" v-if="attachment.progress<100"></i>
                                                        <i class="icon icon-trash text-secondary fs-20" v-if="attachment.progress == 100" ></i>
                                                    </div>
                                                </div>
                                            </div>    
                                        </div>
                                    </div>
                                </div>    
                            </div>
                        </div>
                    </div>
                </div>
                <div class="v-modal-dialog-actions modal-bg pt-0">
                    <div class="d-flex justify-content-center align-items-center my-3">
                        <button class="btn btn-secondary-outline text-capitalize mr-5 w-150px" @click="hideRejection">Cancel</button>
                        <button class="btn btn-secondary mr-5 text-capitalize w-150px" :disabled="isUploadingInProgress || ajax_loader" :class="{'text-align-left' : ajax_loader}" @click="reject">
                            Confirm
                            <half-circle-spinner v-if='ajax_loader' :animation-duration="1000" :size="20" color="#00448b" style="margin: 0 auto;top:-30px;left:30px" />
                        </button>
                    </div>
                </div>
            </div>
        </modal>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal> 
    </div>
</template>        
<script>
import { HalfCircleSpinner } from "epic-spinners";
import { SweetModal } from 'sweet-modal-vue'
import axios from 'axios';
import ticket from '../mixins/ticket';
import {EventBus} from "../eventBus/nav-bar-event.js";
import { debounce } from 'lodash';
export default {
    mixins: [ticket],
    props: ['modal_name', 'expense_id', 'rejection_data'],
    data(){
        return {
            success_msg:'',
            warning_msg:'',
            isUploadingInProgress: false,
            ajax_loader: false
        }
    },
    methods:{
        hideRejection(){
            this.isUploadingInProgress =false
            this.rejection_data.action.comment = ""
            this.rejection_data.action.attachments = []
            this.$modal.hide(this.modal_name);
            this.$emit("rejectApproval");
            EventBus.$emit('ZindexChangeEnd')

        }, 
        hideRejectionSaved(){
            this.isUploadingInProgress =false
            this.rejection_data.action.comment = ""
            this.rejection_data.action.attachments = []
            this.$modal.hide(this.modal_name);
            this.$emit("rejectApprovalSaved");
        },
        reject(){
            EventBus.$emit('ZindexChangeEnd')
            this.$validator.validateAll().then(result => {
                if (result == true) {
                    this.rejection_data.action.attachments.forEach(attachment => {
                        delete attachment['id'];
                        delete attachment['progress']
                        delete attachment['uploading']
                        delete attachment['error'] 
                    })
                    this.confirmReject();
                }
            })
        },
        confirmReject(){
            this.$validator.validateAll().then(result => {
                if (result == true) {
                    this.ajax_loader = true
                    let payload = this.rejection_data
                    this.ApproveTicketPart(payload).then(response => {
                        if(response.status_id == 1){
                            this.success_msg = "Ticket Rejected Successfully"
                            this.$refs.success_modal.open();
                            setTimeout(() => {
                                this.$refs.success_modal.close();
                                this.ajax_loader = false
                                this.hideRejectionSaved();
                            }, 3000);
                        } else {
                            this.warning_msg = response.reason
                            this.$refs.warning_modal.open();
                            setTimeout(() => {
                                this.ajax_loader = false
                                this.$refs.warning_modal.close();
                            }, 3000);
                        }
                    }).catch(err => {
                        this.ajax_loader = false
                        if(err.hasOwnProperty('reason')){
                            this.warning_msg = err.reason;
                        } else {
                            this.warning_msg = err;
                        }
                        this.$refs.warning_modal.open();
                        setTimeout(() => this.$refs.warning_modal.close(), 2000);
                    })
                }
            })        
        },
        deleteAttachment(attachment,index){
            this.isUploadingInProgress = false
            this.rejection_data.action.attachments.splice(index,1)
            document.getElementById('multiple').value = "";
        },
        dragOverAttachment(evt) {
            // Prevent default behavior (Prevent file from being opened)
            evt.preventDefault();
        },
        dropAttachment(evt) {
            // Prevent default behavior (Prevent file from being opened)
            evt.preventDefault();
            // Use DataTransfer interface to access the file(s)
            [...evt.dataTransfer.files].forEach((file, i) => {
                this.uploadFromDrop(file)
            });
        },
        uploadFromDrop(event) {
            if(event) {
                var input = event;
            }
            if (input && event) {
                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();
                let attachment = {
                    //id: uuidv4(),
                    name: input.name,
                    size: JSON.stringify(input.size),
                    source: source,
                    progress: 0,
                    created_time: new Date(),
                    error: ""
                }
                if(this.rejection_data.action.attachments.length < 10){
                    this.rejection_data.action.attachments.push(attachment);
                    this.getResumable(input, this.rejection_data.action.attachments[this.rejection_data.action.attachments.length - 1]);
                } else {
                    this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
                }
            }
        },
        getResumable(file, attachment) {
            this.isUploadingInProgress = true;
            attachment.uploading = true;
            let data = {
                file: attachment.name
            }
            data = new FormData()
            data.append('file', file)
            this.$http.post('https://cloudapis.digicollect.com/external/upload_file', data, {
                onUploadProgress: function (progressEvent) {
                    let progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent
                        .total));
                    if (progress < 100) {
                        attachment.progress = progress;
                    }
                }.bind(this)
            })
            .then(response => {
                let resumable_url = response.data.url;
                attachment.url = resumable_url;
                attachment.progress = 100;
                attachment.uploading = false;
                this.isUploadingInProgress = false;
                delete attachment['source'];
                setTimeout(() => {
                    // this.saveFiles();
                }, 500);
            })
            .catch(error => {
            })
        },
        uploadAttachment(newFile,oldFile) {
            var input = newFile;
            this.total_file_size = this.total_file_size + input.target.files[0].size
            let contains_duplicates = false
            this.rejection_data.action.attachments.forEach((e) => {
                if(e.name == input.target.files[0].name){
                    contains_duplicates = true
                }
            })
            if(this.rejection_data.action.attachments.length < 10 && !contains_duplicates){
                if (input.target.files) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: input.target.files[0].name,
                        size: JSON.stringify(input.target.files[0].size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: ""
                    }
                    this.rejection_data.action.attachments.push(attachment);
                    this.getResumable(input.target.files[0], this.rejection_data.action.attachments[this.rejection_data.action.attachments.length - 1]);
                }
            } else if(contains_duplicates){
                this.$toasted.global.error("This file is already uploaded")
            } else {
                this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
            }
        },
    },
    components:{
        SweetModal,
        HalfCircleSpinner
    },
    created() {
        const dict = {
            custom: {
                reject:{
                    required:() => "Rejection Note is Required"
                },
            }
        } 
        this.$validator.localize("en", dict);       
    }
}
</script>
<style scoped>
.text-area.form-control{
    height: 145px !important;
}
.text-area{
    border: none !important;
    border-radius: 5px !important;
    padding:5px !important;
    box-shadow: 0 1.5px 15px 0 rgba(0, 0, 0, 0.16) !important;
}
.btn-upload{
    /* background-color: #f5a639; */
    border-radius: 10px !important;
    color: #000;
}
.btn-upload-disabled{
    background-color: #e8e8e8 !important;
    border-radius: 10px !important;
    color: #000;
}
.v-modal-header{
    background-color: #f0ddb7 !important;
    padding:10px 15px !important;
}
.modal-bg{
    background-color: #fff !important;
}
.btn-secondary-outline{
    color: #00448b !important;
    border: 1px solid #00448b !important;
    padding: 0px 20px;
    border-radius: 4px;
    background-color: #fff;
    line-height: 2.4rem !important;
}
.btn-secondary{
    color: #fff !important;
    /* border: 1px solid #00448b !important; */
    padding: 0px 5px !important;
    border-radius: 4px !important;
    background-color: #00448b;
    /* line-height: 2.4rem !important; */
}
.closeModal{
    background-color: #f0ddb7 !important;
}
.v-modal-dialog-title-ar.v-modal-title {
    letter-spacing: .005em;
}

.v-modal-dialog-title-ar {
    margin-bottom: 0px !important;
    font-size: 15px !important;
    font-weight: 600 !important;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    color: #00448b !important;
    text-transform: capitalize !important;
    /* margin: 0 auto !important; */
    padding: 4px !important;
}
.position-absolute{
    position: absolute;
}
.position-relative{
    position: relative !important;
}
.cursor-notallowed{
    cursor: not-allowed !important
}
.text-align-left{
    text-align: left !important;
}
.mx-width-220{
    max-width: 285px !important;
}
</style>                    